module.exports = __webpack_public_path__ + "img/notification.21c6b461.png";